import { makeStyles } from '@material-ui/core';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  article: {
    marginBottom: '0.5rem',
    display: 'flex',
    gap: '0.25rem',
    flexDirection: 'column',
    borderBottom: `1px solid ${neutral[20]}`,
  },

  toppingHeader: {
    color: neutral[100],
    display: 'flex',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > h2': {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
    },
    '& > h2, > span': {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
    '& > h2 > span': {
      paddingRight: '0.25rem',
    },
  },

  stockoutSection: {
    '&[data-has-replacement="true"]': {
      padding: '0.25rem 0.75rem',
      backgroundColor: neutral['10'],
      '& [aria-label="toppingPrice"]': {
        visibility: 'hidden',
      },
    },
  },
});
